<script>
import { onDestroy, onMount, tick } from "svelte";
import { State } from '../../store.js';

import ImageInput from "./ImageInput.svelte";
import BGBlurInput from "./BGBlurInput.svelte";
import ColorInput from "./ColorInput.svelte";
import PercentInput from "./PercentInput.svelte";
import PixelInput from "./PixelInput.svelte";
import Input from "./Input.svelte";
import Select from "./Select.svelte"
import FontSelect from "./FontSelect.svelte"
import Button from '../Button.svelte';
import Icon from '../Icon.svelte'
import TextArea from '../TextArea.svelte'
import IconPicker from './IconPicker.svelte'

export let settings = {}
export let key = ""
let index = 0

let inheritLabel = "Default"

$State.components.forEach((element, i) => {
    $State.components.forEach((element, i) => {
        if (element.id == $State.activeElementId) {
            index = i
            key = element.args.name
        }
    });
});

const isValidTag = (value) => {
    return true
}

export let hidden = true

export let limited = false

$: {
    if (!hidden) {
        let key = settings
    }
}

</script>


{#if settings !== undefined && "style" in settings}
    <div class="inspector">
        <div class="row flex-start">
            
            <Button stretch={true} align={"edges"} clear={true} action="{() => {hidden = !hidden}}">                
                { hidden ? 
                settings.name 
                :
                settings.name
                }

                <img style="transition: all .25s cubic-bezier(0.34, 1.26, 0.64, 1); opacity: 0.618; transform: {hidden ? 'rotate(0deg)' : 'rotate(90deg)'} scale(0.7); " alt="chevron" src="../static/symbols/chevron.right.svg">
            
            </Button>
        </div>

        {#if !hidden}

            <hr>   



            
            {#if !limited}
                <h4>General</h4>
                
                {#each Object.keys(settings) as key}

                    {#if (key == "innerText" || key == "srcdoc")}
                        <div class="row" style="flex-direction: column; align-items: stretch; justify-content: flex-start;">
                            <p style="margin-bottom: 5px;">{key}</p>
                            <div style="margin-left: -5px; margin-right: -5px; margin-top: -20px; margin-bottom: -20px;">
                            <TextArea bind:value={settings[key]} minRows={3} maxRows={10}></TextArea>
                            </div>
                        </div>
                    {:else}
                        {#if (key != "style" && key != "custom")}
                            <div class="row" style="">
                                <p>{key}</p>
                                <Input autosize={false} isValid={isValidTag} defaultValue={settings[key]} defaultLabel={settings[key]} bind:value={settings[key]}></Input>
                            </div>
                        {:else if key == "custom"}
                            
                            {#each Object.keys(settings[key]) as customKey}

                                {#if (customKey == "icon")}
                                    <IconPicker defaultValue={settings[key][customKey].value} defaultLabel={settings[key][customKey].value} bind:value={settings[key][customKey].value}/>
                                {:else}
                                    <div class="row" style="">
                                        <p>{customKey}</p>
                                        <Input autosize={true} isValid={isValidTag} defaultValue={settings[key][customKey].value} defaultLabel={settings[key][customKey].value} bind:value={settings[key][customKey].value}></Input>
                                    </div>
                                {/if}
                            {/each}
                        {/if}
                    {/if}
                {/each}


            
                <h4>Layout</h4>
                
                <div class="row">
                    <p>Display</p>
                    <Select bind:value={settings.style["display"]} values={["","block", "flex", "inline-block", "none"]} labels={["Auto", "Block", "Flex","Inline", "Hidden"]}></Select>
                </div>

                <div class="row">
                    <p>Direction</p>
                    <Select bind:value={settings.style["flex-direction"]} values={["","inherit","row", "column"]} labels={["Default","Inherit", "Horizontal", "Vertical"]}></Select>
                </div>

                {#if settings.style["flex-direction"] == "column"}
                    <div class="row">
                        <p>Horizontal Align</p>
                        <Select bind:value={settings.style["align-items"]} values={["","inherit", "flex-start", "center", "flex-end", "stretch"]} labels={["Default","Inherit", "Left", "Center", "Right", "Stretch"]}></Select>
                    </div>
                    <div class="row">
                        <p>Vertical Align</p>
                        <Select bind:value={settings.style["justify-content"]} values={["","inherit", "flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"]} labels={["Default","Inherit", "Left", "Center", "Right", "Space Between", "Space Around", "Space Evenly"]}></Select>
                    </div>
                {:else}
                    <div class="row">
                        <p>Horizontal Align</p>
                        <Select bind:value={settings.style["justify-content"]} values={["","inherit", "flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"]} labels={["Default","Inherit", "Left", "Center", "Right", "Space Between", "Space Around", "Space Evenly"]}></Select>
                    </div>
                    <div class="row">
                        <p>Vertical Align</p>
                        <Select bind:value={settings.style["align-items"]} values={["","inherit", "flex-start", "center", "flex-end", "stretch"]} labels={["Default","Inherit", "Top", "Center", "Bottom", "Stretch"]}></Select>
                    </div>
                {/if}

                
                <h4>Sizing</h4>

                <div class="row">
                    <p>Height</p>
                    <PixelInput bind:value={settings.style["height"]} defaultValue="auto"></PixelInput>
                </div>

                <div class="row">
                    <p>Width</p>
                    <PixelInput bind:value={settings.style["width"]} defaultValue="auto"></PixelInput>
                </div>
            {/if}

            <h4>Padding</h4>

            <div class="row">
                <p>Top</p>
                <PixelInput bind:value={settings.style["padding-top"]} defaultValue="inherit"></PixelInput>
            </div>
            <div class="row">
                <p>Bottom</p>
                <PixelInput bind:value={settings.style["padding-bottom"]} defaultValue="inherit"></PixelInput>
            </div>
            <div class="row">
                <p>Left</p>
                <PixelInput bind:value={settings.style["padding-left"]} defaultValue="inherit"></PixelInput>
            </div>
            <div class="row">
                <p>Right</p>
                <PixelInput bind:value={settings.style["padding-right"]} defaultValue="inherit"></PixelInput>
            </div>

            {#if !limited}

                <h4>Margins</h4>

                <div class="row">
                    <p>Top</p>
                    <PixelInput bind:value={settings.style["margin-top"]} defaultValue="inherit"></PixelInput>
                </div>
                <div class="row">
                    <p>Bottom</p>
                    <PixelInput bind:value={settings.style["margin-bottom"]} defaultValue="inherit"></PixelInput>
                </div>
                <div class="row">
                    <p>Left</p>
                    <PixelInput bind:value={settings.style["margin-left"]} defaultValue="inherit"></PixelInput>
                </div>
                <div class="row">
                    <p>Right</p>
                    <PixelInput bind:value={settings.style["margin-right"]} defaultValue="inherit"></PixelInput>
                </div>

            {/if}

            <h4>Effects</h4>

            <div class="row">
                <p>BG Color</p>
                <ColorInput bind:settings={settings} key="background-color"/>
            </div>

            <div class="row">
                <p>BG Image</p>
                <ImageInput bind:settings={settings}></ImageInput>
            </div>

            <div class="row">
                <p>BG Position</p>
                <Select bind:value={settings.style["background-position"]} values={["center center", "left top", "left center", "left bottom", "right top", "right center", "right bottom", "center top", "center bottom"]} labels={["center","left top", "left center", "left bottom", "right top", "right center", "right bottom", "center top", "center bottom"]}></Select>
            </div>

            <div class="row">
                <p>BG Size</p>
                <Select bind:value={settings.style["background-size"]} values={["auto", "cover", "contain"]} labels={["auto", "cover", "contain"]}></Select>
            </div>

            <div class="row">
                <p>BG Repeat</p>
                <Select bind:value={settings.style["background-repeat"]} values={["repeat", "no-repeat"]} labels={["repeat", "no-repeat"]}></Select>
            </div>

            <div class="row">
                <p>BG Blur</p>
                <BGBlurInput bind:settings={settings}/>
            </div>

            <!-- <div class="row">
                <p>BG Repeat</p>
                <Select bind:value={settings.style["background-repeat"]} values={["cover", "contain"]} labels={["Full Width", "Contain"]}></Select>
            </div> -->
            

            {#if !limited}

                <div class="row">
                    <p>Corner Radius</p>
                    <PixelInput bind:value={settings.style["border-radius"]} defaultValue="default"></PixelInput>
                </div>

                <div class="row">
                    <p>Opacity</p>
                    <PercentInput bind:value={settings.style["opacity"]} ></PercentInput>
                </div>
            
                {/if}

            <h4>Typography</h4>
            {#if !limited}
                <div class="row">
                    <p>Text Align</p>
                    <Select bind:value={settings.style["text-align"]} values={['',"left", "center", "right"]} labels={["Inherit","Left", "Center", "Right"]}></Select>
                </div>
                <div class="row">
                    <p>Font Size</p>
                    <PixelInput bind:value={settings.style["font-size"]} defaultValue="auto"></PixelInput>
                </div>
            {/if}
            <div class="row">
                <p>Text Color</p>
                <ColorInput bind:settings={settings} key="color"/>
            </div>
            <div class="row">
                <p>Font</p>
                <FontSelect key={key + "." + settings.name} bind:weightValue={settings.style["font-weight"]} bind:fontValue={settings.style["font-family"]}></FontSelect>
            </div>
        {/if}
    </div>
{/if}

<style>

.row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.row.flex-start {
    justify-content: flex-start;
}

.container {
    width: 100%;
    /* padding-left: 100px; */
}

.preview {
    display: none;
}

input, select {
    background-color: var(--secondary-button-bg-color);
    border: 1px solid rgba(0,0,0,0);
    box-shadow: none;
    outline: none;
    color: var(--text-color);
    margin: 0px;
    padding: 3px 6px;
    border-radius: 10px;
    text-align: right;
    font-size: 0.9rem;
}

input:focus, textarea:focus, select:focus, select:focus {

}

h4 {
    /* margin-top: 25px; */
    height: 25px;
    display: flex;
    align-items: center;
    margin-top: 10px;
}


.row > p {
    opacity: 0.618;
    height: 25px;
    /* justify-self: center;
    align-self: center; */
    display: flex;
    align-items: center;
}

.debugButton {
    margin-bottom: -50px;
}


.inspector {
    background-color: var(--light-bg-color);
    margin-bottom: 10px;
    padding: 8px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.1)
}

hr {
    margin: 0px;
    margin-top: 5px;
    height: 1px !important;
    border: none;
    border-bottom: 1px solid white;
}

</style>